import { CellRow } from "@/components/CellGrid/CellRow";
import {
  waterfallAmountForProfitDistributionsFromCoSaleMolecule,
  waterfallAmountForProfitDistributionsFromOpsMolecule,
  waterfallDistributableFCFFromCoSaleMolecule,
  waterfallDistributableFCFFromOpsMolecule,
  waterfallPreferredDividendsAccruedMolecule,
  waterfallPreferredDividendsAccruedPrefBeginBalMolecule,
  waterfallPreferredDividendsAccruedPrefEndBalMolecule,
  waterfallPreferredDividendsAccruedPrefPymtFromCoSaleMolecule,
  waterfallPreferredDividendsAccruedPrefPymtFromOpsMolecule,
  waterfallPreferredDividendsAquisitionInvestorsMolecule,
  waterfallPreferredDividendsPaidMolecule,
  waterfallPreferredDividendsRequiredMolecule,
  waterfallPreferredDividendsSearchPhaseInvestorsMolecule,
  waterfallPreferredDividendsSearchersCoinvestMolecule,
  waterfallPreferredDividendsSellerRolloverMolecule,
  waterfallPrincipalRepaymentAquisitionInvestorsMolecule,
  waterfallPrincipalRepaymentCapitalBeginBalMolecule,
  waterfallPrincipalRepaymentCapitalEndBalMolecule,
  waterfallPrincipalRepaymentCapitalPymtFromCoSaleMolecule,
  waterfallPrincipalRepaymentCapitalPymtFromOpsMolecule,
  waterfallPrincipalRepaymentCumulativePrincipalRepaidMolecule,
  waterfallPrincipalRepaymentSearchPhaseInvestorsMolecule,
  waterfallPrincipalRepaymentSearchersCoinvestMolecule,
  waterfallPrincipalRepaymentSellerRolloverMolecule,
  waterfallProfitDistributionsAcquisitionInvestorsMolecule,
  waterfallProfitDistributionsPromoteSearchersCarryMolecule,
  waterfallProfitDistributionsSearchPhaseInvestorsMolecule,
  waterfallProfitDistributionsSearchersCoinvestMolecule,
  waterfallProfitDistributionsSellerRolloverMolecule,
  waterfallTaxDistributionsAcquisitionInvestorsMolecule,
  waterfallTaxDistributionsPromoteSearchersCarryMolecule,
  waterfallTaxDistributionsSearchPhaseInvestorsMolecule,
  waterfallTaxDistributionsSearchersCoinvestMolecule,
  waterfallTaxDistributionsSellerRolloverMolecule,
  waterfallcompanySaleAcquisitionInvestorsMolecule,
  waterfallcompanySalePromoteSearchersCarryMolecule,
  waterfallcompanySaleSearchPhaseInvestorsMolecule,
  waterfallcompanySaleSearchersCoinvestMolecule,
  waterfallcompanySaleSellerRolloverMolecule,
} from "@/financeModels/owasco/projectionsWaterfallTables";

export const WaterfallDebugTables = () => {
  //priter ignore
  /* prettier-ignore */
  const molecules = [
    "Distributable FCF",
    ["waterfallDistributableFCFFromOpsMolecule",waterfallDistributableFCFFromOpsMolecule],
    ["waterfallDistributableFCFFromCoSaleMolecule",waterfallDistributableFCFFromCoSaleMolecule],
    "Preferred Dividends",
    ["waterfallPreferredDividendsRequiredMolecule",waterfallPreferredDividendsRequiredMolecule],
    ["waterfallPreferredDividendsPaidMolecule",waterfallPreferredDividendsPaidMolecule],
    ["waterfallPreferredDividendsAccruedMolecule",waterfallPreferredDividendsAccruedMolecule],
    ["waterfallPreferredDividendsAccruedPrefBeginBalMolecule",waterfallPreferredDividendsAccruedPrefBeginBalMolecule],
    ["waterfallPreferredDividendsAccruedPrefPymtFromOpsMolecule",waterfallPreferredDividendsAccruedPrefPymtFromOpsMolecule],
    ["waterfallPreferredDividendsAccruedPrefPymtFromCoSaleMolecule",waterfallPreferredDividendsAccruedPrefPymtFromCoSaleMolecule],
    ["waterfallPreferredDividendsAccruedPrefEndBalMolecule",waterfallPreferredDividendsAccruedPrefEndBalMolecule],
    ["waterfallPreferredDividendsSearchPhaseInvestorsMolecule",waterfallPreferredDividendsSearchPhaseInvestorsMolecule],
    ["waterfallPreferredDividendsAquisitionInvestorsMolecule",waterfallPreferredDividendsAquisitionInvestorsMolecule],
    ["waterfallPreferredDividendsSearchersCoinvestMolecule",waterfallPreferredDividendsSearchersCoinvestMolecule],
    ["waterfallPreferredDividendsSellerRolloverMolecule",waterfallPreferredDividendsSellerRolloverMolecule],
    "Principal Repayment",
    ["waterfallPrincipalRepaymentCapitalBeginBalMolecule",waterfallPrincipalRepaymentCapitalBeginBalMolecule],
    ["waterfallPrincipalRepaymentCapitalPymtFromOpsMolecule",waterfallPrincipalRepaymentCapitalPymtFromOpsMolecule],
    ["waterfallPrincipalRepaymentCapitalPymtFromCoSaleMolecule",waterfallPrincipalRepaymentCapitalPymtFromCoSaleMolecule],
    ["waterfallPrincipalRepaymentCapitalEndBalMolecule",waterfallPrincipalRepaymentCapitalEndBalMolecule],
    ["waterfallPrincipalRepaymentCumulativePrincipalRepaidMolecule",waterfallPrincipalRepaymentCumulativePrincipalRepaidMolecule],
    ["waterfallPrincipalRepaymentSearchPhaseInvestorsMolecule",waterfallPrincipalRepaymentSearchPhaseInvestorsMolecule],
    ["waterfallPrincipalRepaymentAquisitionInvestorsMolecule",waterfallPrincipalRepaymentAquisitionInvestorsMolecule],
    ["waterfallPrincipalRepaymentSearchersCoinvestMolecule",waterfallPrincipalRepaymentSearchersCoinvestMolecule],
    ["waterfallPrincipalRepaymentSellerRolloverMolecule",waterfallPrincipalRepaymentSellerRolloverMolecule],
    "Amount For Profit Distributions",
    ["waterfallAmountForProfitDistributionsFromOpsMolecule",waterfallAmountForProfitDistributionsFromOpsMolecule],
    ["waterfallAmountForProfitDistributionsFromCoSaleMolecule",waterfallAmountForProfitDistributionsFromCoSaleMolecule],
    "Profit Distributions (from Ops.)",
    ["waterfallProfitDistributionsSearchPhaseInvestorsMolecule",waterfallProfitDistributionsSearchPhaseInvestorsMolecule],
    ["waterfallProfitDistributionsAcquisitionInvestorsMolecule",waterfallProfitDistributionsAcquisitionInvestorsMolecule],
    ["waterfallProfitDistributionsSearchersCoinvestMolecule",waterfallProfitDistributionsSearchersCoinvestMolecule],
    ["waterfallProfitDistributionsSellerRolloverMolecule",waterfallProfitDistributionsSellerRolloverMolecule],
    ["waterfallProfitDistributionsPromoteSearchersCarryMolecule",waterfallProfitDistributionsPromoteSearchersCarryMolecule],
    "Company Sale Proceeds",
    ["waterfallcompanySaleSearchPhaseInvestorsMolecule",waterfallcompanySaleSearchPhaseInvestorsMolecule],
    ["waterfallcompanySaleAcquisitionInvestorsMolecule",waterfallcompanySaleAcquisitionInvestorsMolecule],
    ["waterfallcompanySaleSearchersCoinvestMolecule",waterfallcompanySaleSearchersCoinvestMolecule],
    ["waterfallcompanySaleSellerRolloverMolecule",waterfallcompanySaleSellerRolloverMolecule],
    ["waterfallcompanySalePromoteSearchersCarryMolecule",waterfallcompanySalePromoteSearchersCarryMolecule],
    "Tax Distributions",
    ["waterfallTaxDistributionsSearchPhaseInvestorsMolecule",waterfallTaxDistributionsSearchPhaseInvestorsMolecule],
    ["waterfallTaxDistributionsAcquisitionInvestorsMolecule",waterfallTaxDistributionsAcquisitionInvestorsMolecule],
    ["waterfallTaxDistributionsSearchersCoinvestMolecule",waterfallTaxDistributionsSearchersCoinvestMolecule],
    ["waterfallTaxDistributionsSellerRolloverMolecule",waterfallTaxDistributionsSellerRolloverMolecule],  
    ["waterfallTaxDistributionsPromoteSearchersCarryMolecule",waterfallTaxDistributionsPromoteSearchersCarryMolecule],
  ] as const

  let tabY = 999999;

  return (
    <>
      <div
        style={{
          background: "red",
        }}
      >
        WATER FALL DEBUG
      </div>

      {molecules.map((molecule, index) => {
        if (typeof molecule === "string") {
          return <div key={index}>{molecule}</div>;
        } else {
          return (
            <CellRow
              key={index}
              label={<div style={{ fontSize: 10 }}>{molecule[0]}</div>}
              tabY={tabY++}
              molecule={molecule[1]}
            />
          );
        }
      })}
    </>
  );
};
